import { Pipe, PipeTransform } from '@angular/core';

import { tituloReceberSituacoes } from '../titulo-receber-situacao';

@Pipe({
    name: 'tituloReceberSituacao'
})
export class TituloReceberSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = tituloReceberSituacoes.findIndex(status => status.id === value);
        if (index > -1) {
            return tituloReceberSituacoes[index].nome;
        }
        return '';
    }
}
